// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sizzlipede: PokeData = {
  "id": 850,
  "name": "sizzlipede",
  "height": 7,
  "weight": 10,
  "base_experience": 61,
  "types": [
    PokeType.FIRE,
    PokeType.BUG
  ],
  "api_moves": [
    "slam",
    "wrap",
    "bite",
    "ember",
    "fire-spin",
    "smokescreen",
    "flame-wheel",
    "crunch",
    "bug-bite",
    "coil",
    "lunge",
    "fire-lash",
    "burn-up"
  ],
  "moves": [
    "bite",
    "ember",
    "fire-spin",
    "crunch",
    "bug-bite",
    "lunge",
    "fire-ball",
    "morning-sun",
    "magma-storm",
    "pounce",
    "signal-spam",
    "flamethrower",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 447,
    "item": null,
    "species": [
      {
        "name": "sizzlipede",
        "order": 850,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "centiskorch",
        "order": 851,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": 850,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 48.75,
    "speed": 45,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
